import React, { useEffect, useState, useRef } from "react";
import { makeStyles, Theme, createStyles, withStyles } from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import {
  getReportTemplate,
  getReportTemplateParameter,
  getGenerateReportList,
} from "../actions/LimsAdminActions";
import { Grid, Paper, TablePagination, TableFooter } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
      marginTop: "20px",
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    contentTable: {
      width: "100%",
      padding: "10px 0px 10px 0px",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    card: {
      height: "100%",
      padding: theme.spacing(1),
    },
    card_grid: {
      justifyContent: "space-between",
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    tableHead: {
      background: "rgb(146, 74, 145)!important",
    },
  })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#1C4E80",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
interface Props {
  loading: boolean;
  getReportTemplate: any;
  reportList: any;
  reportListParameter: any;
  getReportTemplateParameter: any;
  fetchNotGenReportList: any;
  getGenerateReportList: any;
}

const GenerateReport: React.FC<Props> = ({
  loading,
  getReportTemplate,
  reportList,
  getReportTemplateParameter,
  reportListParameter,
  fetchNotGenReportList,
  getGenerateReportList,
}) => {
  const navigate = useNavigate();
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [bookingId, setBookingId] = useState<any>();
  const [endId, setEndId] = useState("");
  const [reportData, setReportData] = useState("");
  const [templateCode, setTemplateCode] = useState("");
  const [allData, setAllData] = useState("");
  const [page, setPage] = useState(0);
  const rowsPerPage = 20;

  const handleReportData = (allData: React.SetStateAction<string>) => setAllData(allData);

  const submitFile = async (e: any) => {
    e.preventDefault();
    getReportTemplateParameter(`booking_id=${bookingId}&template_id=${reportData}`);

    switch (String(templateCode)) {
      case "BRCA":
        navigate(`/dashboard/la/brca-report/${bookingId}/${reportData}/add`);
        break;
      case "NIPT":
        navigate(`/dashboard/la/nipt-report/${bookingId}/${reportData}/add`);
        break;
      case "NSP":
        navigate(`/dashboard/la/nsp-report/${bookingId}/${reportData}/add`);
        break;
      case "Allergy":
        navigate(`/dashboard/la/allergy-report/${bookingId}/${reportData}/add`);
        break;
      case "ABL":
        navigate(`/dashboard/la/abl-report/${bookingId}/${reportData}/add`);
        break;
      case "HLA":
        navigate(`/dashboard/la/hla-report/${bookingId}/${reportData}/add`);
        break;
      case "JAK":
        navigate(`/dashboard/la/jak-report/${bookingId}/${reportData}/add`);
        break;
      case "PML":
        navigate(`/dashboard/la/pml-report/${bookingId}/${reportData}/add`);
        break;
      case "MCC":
        navigate(`/dashboard/la/mcc-report/${bookingId}/${reportData}/add`);
        break;
      case "BCRQ":
        navigate(`/dashboard/la/bcrq-report/${bookingId}/${reportData}/add`);
        break;
      case "QFPCR":
        navigate(`/dashboard/la/qfpcr-report/${bookingId}/${reportData}/add`);
        break;
      case "CMA315":
        navigate(`/dashboard/la/cma315-report/${bookingId}/${reportData}/add`);
        break;
      case "CMA750":
        navigate(`/dashboard/la/cma750-report/${bookingId}/${reportData}/add`);
        break;
      case "SANGERSEQUENCING":
        navigate(`/dashboard/la/sangersequencing-report/${bookingId}/${reportData}/add`);
        break;
      case "HBB":
        navigate(`/dashboard/la/hbb-report/${bookingId}/${reportData}/add`);
        break;
      case "DNA":
        navigate(`/dashboard/la/dna-report/${bookingId}/${reportData}/add`);
        break;
      case "SMNMLPA":
        navigate(`/dashboard/la/smnmlpa-report/${bookingId}/${reportData}/add`);
        break;
      case "DMDMLPA":
        navigate(`/dashboard/la/dmdmlpa-report/${bookingId}/${reportData}/add`);
        break;
        case "IRMA":
        navigate(`/dashboard/la/irma-report/${bookingId}/${reportData}/add`);
        break;
        case "FACTORV":
          navigate(`/dashboard/la/factorv-report/${bookingId}/${reportData}/add`);
          break;
      case "FACTORII":
          navigate(`/dashboard/la/factorII-report/${bookingId}/${reportData}/add`);
          break;
      case "MEN1":
      case "MEN1GENESEQUENCING":
        navigate(`/dashboard/la/men1-gene-sequencing/${bookingId}/${reportData}/add`);
        break;
      default:
        break;
    }
  };

  const onKeyDown = (e: any) => {
    if (e.key === "Enter") {
      submitFile(e);
    }
  };
  const resethandler = () => {
    localStorage.removeItem("CEBookingFilter");
    navigate(0)
  }
  useEffect(() => {
    getReportTemplate();
    getGenerateReportList();

  }, [])

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = fetchNotGenReportList.links.next.split("?")[1];
      getGenerateReportList(`?${url}`)

    } else if (newPage < page) {
      let url = fetchNotGenReportList.links.previous.split("?")[1];
      getGenerateReportList(`?${url}`)

    }
    setPage(newPage);
  };

  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <div className="main-right">
        <div className="reset-user-password">
          <div className={classes.contentHeader}>
            <h2 style={{ fontWeight: "bold" }}>Generate Report</h2>
          </div>
          <div className={classes.contentTable}>
            <Grid container spacing={1} direction="row">
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  id="Template Name"
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                      setReportData(obj?.id);
                      setTemplateCode(obj?.template_code)
                    }
                  }}
                  options={reportList || []}
                  blurOnSelect
                  disableClearable={reportList === ""}
                  disableCloseOnSelect
                  getOptionLabel={(option: any) => `${option?.template_name ? option?.template_name : []}`}
                  onInputChange={(event, newInputValue) => {
                    clearTimeout(timer.current);
                    timer.current = setTimeout(() => {
                      getReportTemplate(`code=${newInputValue}`);
                    }, 1000);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="input"
                      label="Report Template"
                      variant="outlined"
                      placeholder="Report Template"
                      fullWidth
                    />
                  )}

                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  id="bookingId"
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                      setBookingId(obj?.pk);
                    }
                  }}
                  options={fetchNotGenReportList.results || []}
                  freeSolo
                  blurOnSelect
                  aria-required
                  getOptionLabel={(option: any) => {
                    return (
                      (option?.pk)
                    );
                  }}
                  onInputChange={(event, newInputValue) => {
                    clearTimeout(timer.current);
                    timer.current = setTimeout(() => {
                      getGenerateReportList(`?booking_id=${newInputValue}`);
                    }, 1000);
                    if (newInputValue.length === 0) {
                      setBookingId(0);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      className="input"
                      {...params}
                      label="Booking Id"
                      placeholder="Select Booking Id"
                      variant="outlined"
                      style={{ width: "100%", margin: "0", padding: "0" }}
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <Button
                  variant="contained"
                  type="submit"
                  color="secondary"
                  fullWidth
                  disabled={!bookingId}
                  className={classes.submit}
                  onClick={submitFile}
                >
                  Submit
                </Button>
              </Grid>
              <Grid item xs={12} sm={4} md={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => resethandler()}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <TableContainer
        className={classes.tableContainer}
        component={Paper}
        style={{ maxHeight: "550px" }}
      >
        <h5>Patient List(Report Not Generated)</h5>
        <Table stickyHeader aria-label="simple table">
          <TableHead className={classes.tableHead}>
            <StyledTableRow>
              <StyledTableCell align="center">Booking Id</StyledTableCell>
              <StyledTableCell align="center">Patient Name</StyledTableCell>
              <StyledTableCell align="center">Report Type</StyledTableCell>
              <StyledTableCell align="center">Center Name</StyledTableCell>
              <StyledTableCell align="center">City</StyledTableCell>
              <StyledTableCell align="center">Pickup Date</StyledTableCell>
              <StyledTableCell align="center">Report Status</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {fetchNotGenReportList &&
              fetchNotGenReportList?.results &&
              fetchNotGenReportList?.results?.length > 0 &&
              fetchNotGenReportList?.results?.map((data: any, index: any) => {
                return (
                  <StyledTableRow>
                    <StyledTableCell align="center">
                      {data?.pk}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.customer_name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.org_type}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.center?.name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.city}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.pickup_date}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.report_status}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
          <TableFooter>
            <TablePagination
              colSpan={6}
              count={fetchNotGenReportList.count || 0}
              rowsPerPageOptions={[]}
              rowsPerPage={rowsPerPage}
              // onChangeRowsPerPage={handleChangeRowsPerPage}
              page={page}
              SelectProps={{
                native: true,
              }}
              onPageChange={handleChangePage}
            />
          </TableFooter>
        </Table>
      </TableContainer>
    </main >
  );
};

const mapStateToProps = (state: any) => ({
  loading: state.LimsAdminReducer.loading,
  reportList: state.LimsAdminReducer.reportList,
  reportListParameter: state.LimsAdminReducer.reportListParameter,
  fetchNotGenReportList: state.LimsAdminReducer.fetchNotGenReportList,
});

export default connect(mapStateToProps, {
  getReportTemplate,
  getReportTemplateParameter,
  getGenerateReportList,
})(GenerateReport);
